import { Component, OnInit,Inject } from '@angular/core';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-delete-group-dialog',
  templateUrl: './delete-group-dialog.component.html',
  styleUrls: ['./delete-group-dialog.component.css']
})
export class DeleteGroupDialogComponent implements OnInit {

  failMsg:string;
  constructor(public restApiService:RestApiService,@Inject(MAT_DIALOG_DATA) public data: any,public deleteGroupDialogComponent: MatDialogRef<DeleteGroupDialogComponent>) { }

  ngOnInit() {
  }

  confirmDelete()
  {
    this.restApiService.deleteGroupService({id:this.data}).subscribe(
      result => {
        // console.log(result);
        if(result.success)
        {
          this.deleteGroupDialogComponent.close(result);
        }
        else
        {
          this.failMsg = result.msg;
        }

      });
  }

  discard()
  {
    this.deleteGroupDialogComponent.close({success:false});
  }
}



// WEBPACK FOOTER //
// ./src/app/delete-group-dialog/delete-group-dialog.component.ts